import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Utils/NewIcon';
import './style.scss';
import AddressFields from 'components/Patient/EditAddress/AddressFields';
import GoogleMap from 'components/Utils/GoogleMap';
import MiscUtils from 'services/MiscUtils';
import DefaultButton from 'components/Utils/NewDefaultButton';
import PerformanceUtils from 'services/PerformanceUtils';
import { useAppSelector } from 'careand-redux/store';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';

const google = window.google;

const AddressSidePanel = (props) => {
  const { onClose, appointment, updateAppointment } = props;

  const clinic = useAppSelector((state) => state.resource.clinic);
  const [appointmentLatLng, setAppointmentLatLng] = useState(null);

  useEffect(() => {
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode(
      { address: MiscUtils.getFullAddress(appointment.address) },
      (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          setAppointmentLatLng(results[0].geometry.location);
        } else {
          console.error('Geocode error: ' + status);
        }
      },
    );
  }, [appointment]);

  function getLatLng(address) {
    if (!!address?.latitude && !!address?.longitude) {
      return new google.maps.LatLng({
        lat: parseFloat(address.latitude),
        lng: parseFloat(address.longitude),
      });
    }
  }

  const clinicLatLng = getLatLng(clinic.address);

  return (
    <div className="address-side-panel full-height">
      <div className="row top-row">
        <div className="close">
          <Icon className="white" src="xmark" onClick={onClose} />
        </div>
        <span className="large-title">Appointment Address</span>
      </div>
      <div className="content padded-box scroll-list">
        {clinicLatLng && appointmentLatLng && (
          <div style={{ height: '350px', width: '100%' }}>
            <GoogleMap
              currentPosition={clinicLatLng}
              center={appointmentLatLng}
              latLngs={[appointmentLatLng]}
              zoom={13}
            />
          </div>
        )}
        <div className="row">
          <MyAddressFields appointment={appointment} updateAppointment={updateAppointment} />
        </div>
      </div>
    </div>
  );
};

const MyAddressFields = (props) => {
  const dispatch = useAppDispatch();
  const [editMode, setEditMode] = useState(false);
  const [saving, setSaving] = useState(false);
  const [address, setAddress] = useState({});

  let { appointment } = props;

  function onAddressChange(event) {
    setAddress({
      ...address,
      [event.target.name]: event.target.value,
    });
  }

  async function saveAddressChanges() {
    setSaving(true);
    let result = await dispatch(
      api.Appointments.updateAppointment({
        confirmSlot: true,
        appointment: { ...appointment, address },
      }),
      {
        title: 'Appointment Address',
        successText: 'Appointment address updated successfully!',
      },
    );
    setSaving(false);
    if (result) setEditMode(false);
  }

  let buttonStyle = { marginTop: '10px', width: '45%' };

  return (
    <div>
      {editMode && (
        <>
          <AddressFields
            showNotes={true}
            address={address}
            onChange={onAddressChange}
            onSearchResult={setAddress}
            style={{ width: '100%' }}
          />
          <DefaultButton
            name="Cancel"
            style={{ ...buttonStyle, marginRight: '15px' }}
            disabled={saving}
            onClick={() => setEditMode(false)}
          />
          <DefaultButton
            name="Save"
            style={buttonStyle}
            loading={saving}
            onClick={saveAddressChanges}
          />
        </>
      )}
      {!editMode && (
        <>
          <span className="small-title">Address</span>
          <span className="full-address row">
            {MiscUtils.getFullAddress(appointment.address, true)}
          </span>
          <DefaultButton
            name="Edit Address"
            style={{ marginTop: '10px' }}
            onClick={() => {
              setEditMode(true);
              setAddress(PerformanceUtils.clone(appointment.address || {}));
            }}
          />
        </>
      )}
    </div>
  );
};

AddressSidePanel.propTypes = {
  bubble: PropTypes.object,
  appointment: PropTypes.object.isRequired,
  onClose: PropTypes.func,
};

export default AddressSidePanel;
